import React, { useEffect, useState, useCallback } from "react";
import Header from "../../../components/header/header";
import Toast from "../../../components/Toast";
import api from "../../../services/api";
import AdicionarMarca from "../../../components/modalAdicionar/adicionarMarca";
import {
    Box,
    Tela,
    Buscar,
    InlineStyle,
    InlineStylePages,
    BotoesNavegar,
    Paginas,
} from "../ingredientes/ingredientes-style";
import BoxMarca from "../../../components/box-listas/box-marca";
import SearchIcon from "@material-ui/icons/Search";
import NamePages from "../../../components/NamePages";
import {
    HeaderTable,
    TextHeaderTable,
    ClickableArea,
    ContainerHeaderTable,
} from "../../../components/HeaderTable/styles";
import ButtonOrderBy from "../../../components/buttonOrderBy";
import { RowButtonsOrderby } from "../../../components/buttonOrderBy/styles";
import { Buscar2 } from "../usuarios/usuarios-style";
import Next from "../../../assets/next.svg";

function Marcas() {
    const [, setMarcas] = useState([]);
    const [marcasFiltradas, setMarcasFiltradas] = useState([]);
    const [busca, setBusca] = useState("");
    const [orderBySelect, setOrderBySelect] = useState("nome");
    const [typeOrder, setTypeOrder] = useState("ascendent");
    const [isEmpty, setIsEmpty] = useState(false);
    const [numeroDaPagina, setNumeroDaPagina] = useState(1);
    const [numeroTotalPaginas, setNumeroTotalPaginas] = useState(1);



    const onPressButtonOrder = (order) => {
        if (order === orderBySelect) {
            typeOrder === "ascendent" ? setTypeOrder("descendent") : setTypeOrder("ascendent")
        } else {
            setTypeOrder("ascendent")
            setOrderBySelect(order)
        }
    }

    const GetMarcas = useCallback(async () => {
        try {
            const res = await api.get(`/api/marcas?ordering=${typeOrder === "ascendent" ? "" : "-"}${orderBySelect}&page=1&search=${busca}`);
            if (res.data.results.length === 0) {
                setIsEmpty(true);
            } else {
                setIsEmpty(false);
            }
            setMarcas(res.data.results);
            setMarcasFiltradas(res.data.results);
            setNumeroDaPagina(1);
            setNumeroTotalPaginas(Math.ceil(res.data.count / 15));

            // Reset paginas array if needed or logic adjustments
            // Assuming paginas array is just for rendering loops if used, but here logic seems slightly off in original code (pushing to state var), but sticking to structure.
        } catch (error) {
            console.log(error);
        }
    }, [typeOrder, orderBySelect, busca]);

    useEffect(() => {
        const timer = setTimeout(() => GetMarcas(), 500);
        return () => clearTimeout(timer);
    }, [GetMarcas]);

    const PaginaAtual = async (data) => {
        if (data > 0 && data <= numeroTotalPaginas) {
            setNumeroDaPagina(data);
            const response = await api.get(
                `/api/marcas?ordering=${typeOrder === "ascendent" ? "" : "-"}${orderBySelect}&page=${data}&search=${busca}`
            );
            setMarcas(response.data.results);
            setMarcasFiltradas(response.data.results);
        }
    };

    const SearchPagina = async (data) => {
        if (data === '') {
            setNumeroDaPagina(1);
            const response = await api.get(
                `/api/marcas?page=${1}&search=${busca}`
            );
            setMarcas(response.data.results);
            setMarcasFiltradas(response.data.results);
        }
        else {
            setNumeroDaPagina(data);
            const response = await api.get(
                `/api/marcas?page=${data}&search=${busca}`
            );
            setMarcas(response.data.results);
            setMarcasFiltradas(response.data.results);
        }
    };

    return (
        <>
            <Toast />
            <div>
                <Header />
                <Tela>
                    <NamePages BackgroundColor={"#E6AC86"} NamePage={"Gerenciar Marcas"} />
                    <InlineStyle>
                        <Buscar>
                            <SearchIcon />
                            <input
                                type="text"
                                placeholder="Buscar Marca"
                                onChange={(event) => setBusca(event.target.value)}
                            />
                        </Buscar>
                        <AdicionarMarca GetMarcas={GetMarcas} />
                    </InlineStyle>
                    {isEmpty ? null : (
                        <InlineStylePages>
                            {numeroDaPagina > 1 && (
                                <BotoesNavegar
                                    type="button"
                                    onClick={() => PaginaAtual(numeroDaPagina - 1)}
                                >
                                    <img src={Next} alt="Voltar" className="rotateimg180" />
                                </BotoesNavegar>
                            )}
                            <Paginas>
                                <button
                                    onClick={() => PaginaAtual(numeroDaPagina)}
                                    style={{ backgroundColor: "#E6AC86" }}
                                >
                                    {numeroDaPagina}
                                </button>
                                {/* Simplificando a paginação para manter o código limpo, adicionar mais botões se necessário como no original */}
                                {numeroDaPagina < numeroTotalPaginas && (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 1)}>
                                        {numeroDaPagina + 1}
                                    </button>
                                )}
                            </Paginas>
                            {numeroDaPagina < numeroTotalPaginas && (
                                <BotoesNavegar
                                    type="button"
                                    onClick={() => PaginaAtual(numeroDaPagina + 1)}
                                >
                                    <img src={Next} alt="Avançar" />
                                </BotoesNavegar>
                            )}
                            <Buscar2>
                                <input
                                    type="number"
                                    placeholder="Pág..."
                                    onChange={(event) => { SearchPagina(event.target.value) }}
                                />
                            </Buscar2>
                        </InlineStylePages>
                    )}
                    <RowButtonsOrderby>
                        <ButtonOrderBy
                            onPress={() => { onPressButtonOrder('nome') }}
                            title={typeOrder === "ascendent" ? "clique para ordenar de forma descendente" : "clique para ordenar de forma ascendete"}
                            isSelected={orderBySelect === 'nome' ? true : false}
                            type="string"
                            ascendent={typeOrder}
                            text="Nome"
                        />
                    </RowButtonsOrderby>
                    <HeaderTable
                        backgroundColor="#A5553C"
                    >
                        <ContainerHeaderTable
                            width="80"
                            minWidth="100"
                            justify="start"
                            marginLeft={30}
                            marginRight={10}
                        >
                            <ClickableArea>
                                <TextHeaderTable>Nome da Marca</TextHeaderTable>
                            </ClickableArea>
                        </ContainerHeaderTable>
                        <ContainerHeaderTable
                            // width="15"
                            minWidth="90"
                            justify="space-evenly"
                            marginLeft={0}
                            marginRight={30}
                        >
                            <ClickableArea>
                                <TextHeaderTable>Opções</TextHeaderTable>
                            </ClickableArea>
                        </ContainerHeaderTable>
                    </HeaderTable>
                    <Box>
                        {marcasFiltradas.map((data) => (
                            <div key={data.id}>
                                <BoxMarca
                                    nome={data.nome}
                                    descricao={data.descricao}
                                    imagem={data.image_url}
                                    id={data.id}
                                    GetMarcas={GetMarcas}
                                />
                            </div>
                        ))}
                    </Box>
                </Tela>
            </div>
        </>
    );
}
export default Marcas;
